import { render, staticRenderFns } from "./DepartmentDesignation.vue?vue&type=template&id=7f9a471a&scoped=true"
import script from "./DepartmentDesignation.vue?vue&type=script&lang=js"
export * from "./DepartmentDesignation.vue?vue&type=script&lang=js"
import style0 from "./DepartmentDesignation.vue?vue&type=style&index=0&id=7f9a471a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9a471a",
  null
  
)

export default component.exports